import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { SerialCreditApplicationRequest, SerialCreditApplicationResponse } from '../models/models'

export class DeleteDocumentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'compay-payment/DeleteDocument',
      requesterInfo,
    })
  }
  public async deleteDocument(req: any): Promise<boolean> {
    return await this.postAsync<boolean>(req)
  }
}
